import { typography } from 'assets/styles'
import styled from 'styled-components'

export const NoticeBoxWrapper = styled.div`
    box-shadow: 4px 4px 5px #d5d9e0;
`

export const BannerText = styled.div`
    ${typography.BannerText};
    color: ${(props) => props.theme.colors.monochrome.jetlineBlack};
`
